

<main class="body-content">

  <!-- Navigation Bar -->
  <nav class="navbar ms-navbar" style=" margin: unset;">
    <div class="ms-aside-toggler ms-toggler pl-0" data-target="#ms-side-nav" data-toggle="slideLeft"> <span
        class="ms-toggler-bar bg-primary"></span>
      <span class="ms-toggler-bar bg-primary"></span>
      <span class="ms-toggler-bar bg-primary"></span>
    </div>
  
  </nav>

  <div class="row page-titles ms-panel" style="margin-right: unset;  margin-left: unset;padding-top: 9px;">

    <div class="col-md-5 align-self-center">
      <h4 class="text-themecolor">Restaurant</h4>


    </div>

    <div class="col-md-7 align-self-center text-right">
      <div class="d-flex justify-content-end align-items-center" *ngIf="Drop">
        <button type="button" class="btn btn-info d-none d-lg-block m-l-15" style="margin-bottom: 10px;"
          (click)="Show()"><i class="fa fa-plus-circle"></i> Add Restaurant</button>
      </div>
    </div>
    <div *ngIf="!Drop " style="    margin-top: 20px;">
      <div class="col-md-12" id="Menus">
        <div class="">
          <button id="Menu" tabindex="92" class="accordion" style="display: block;">Restaurant Details</button>
        </div>


      </div>
      <div class="col-md-12" style="padding-top: 30px;padding-bottom: 30px;">
        <div class="col-md-12">

          <div class="col-md-4 ">
            <div class="form-group">
              <label class="control-label">Restaurant Name</label>
              <input type="text" class="form-control " placeholder="Name" [(ngModel)]="ResName">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">SSN</label>
              <input type="text" class="form-control" placeholder="SSN" [(ngModel)]="SSN">
            </div>
          </div>
        </div>

        <!--/span-->
        <div class="col-md-12">
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">Email Id</label>
              <input type="text" class="form-control" placeholder="Email Id" [(ngModel)]="EmailId">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">Mobile Number</label>
              <input type="text" class="form-control" placeholder="Mobile Number"  maxlength="13" [(ngModel)]="MobileNo" (ngModelChange)="onMobileChange($event)" >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label" >Phone Number</label>
              <input type="text" class="form-control" placeholder="Phone Number" [(ngModel)]="PhoneNo">
            </div>
          </div>

        </div>

      </div>

      <div class="col-md-12" id="Menus">
        <div class="">
          <button id="Menu" tabindex="92" class="accordion" style="display: block;">Address Details</button>
        </div>


      </div>
      <div class="col-md-12" style="padding-top: 30px;padding-bottom: 30px;">

        <div class="col-md-4">
          <div class="form-group">
            <label class="control-label">Address Line1</label>
            <input type="text" class="form-control" placeholder="Address Line1" [(ngModel)]="AddressLine1">
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="control-label">Address Line2</label>
            <input type="text" class="form-control" placeholder="Address Line2" [(ngModel)]="AddressLine2">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label">City</label>
            <div class="">
              <!-- <span><i class="ion-upload m-r-5"></i>Item Image</span> -->
              <input type="text" class=" form-control" placeholder="City" [(ngModel)]="City"> </div>
          </div>
        </div>

        <div class="col-md-3" style="padding-top: 30px;">
          <div class="form-group">
            <label class="control-label">State</label>
            <div class="">
              <!-- <span><i class="ion-upload m-r-5"></i>Item Image</span> -->
              <input type="text" class=" form-control" placeholder="State" [(ngModel)]="State"> </div>
          </div>
        </div>
        <div class="col-md-3" style="padding-top: 30px;">
          <div class="form-group">
            <label class="control-label">ZIP</label>
            <div class="">
              <!-- <span><i class="ion-upload m-r-5"></i>Item Image</span> -->
              <input type="number" class=" form-control" placeholder="ZIP"  maxlength="7" [(ngModel)]="Zip"> </div>
          </div>
        </div>
        <div class="col-md-3" style="padding-top: 30px;">
          <div class="form-group">
            <label class="control-label">Google Location</label>
            <div class="">
              <!-- <span><i class="ion-upload m-r-5"></i>Item Image</span> -->
              <input type="text" class=" form-control" placeholder="Location" [(ngModel)]="Location"> </div>
          </div>
        </div>

      </div>
      <div class="col-md-12" style="padding-bottom: 30px;">
        <div class="col-md-6">
          <div class="col-md-3" style="padding-top: 39px;" [(ngModel)]="Status" (change)="toggleEditable($event)"
            [hidden]="isShownActive">
            <input type="checkbox"> Set As In Active
          </div>


          <div class="col-md-3" style="padding-top: 22px;">
            <button class="btn " style="background: #ED562E; color: white;border-radius: 4px;" (click)="InsertResturant()"
              [hidden]="isShownSaveBtn">SAVE</button>
            <button class="btn " style="background: #ED562E; color: white;border-radius: 4px;" (click)="UpdateResturant()"
              [hidden]="isShownUpdateBtn">Update</button>
          </div>
          <div class="col-md-3" style="padding-top: 22px;">
            <button class="btn " style="background: white; color: black;;border-radius: 4px;border-color: #ED562E;"
              (click)="Clear()">CLEAR</button>
          </div>
        </div>
      </div>
      <div class="col-md-12" style="padding-bottom: 25px; text-align: center;">
        <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
        <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
      </div>
    </div>
    <!--/span-->
  </div>

  <div class="ms-content-wrapper">
    <div class="row">

      <div class="col-md-12">

        <div class="ms-panel">
          <div class="ms-panel-body">
            <div class="table-responsive">
              <div id="data-table-5_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div class="dataTables_length" id="data-table-5_length">
                      <label style="padding-right: 25px;">Search</label>
                      <input type="text" placeholder="Search"
                        style="border: unset;background:  #ececec;height: 37px;width: 76%;" [(ngModel)]="searchText"
                        (keyup)="applyFilter($event.target.value)"> <i class="fa fa-search fa-2x"
                        style="color:red;position: absolute;    left: 88%; top: 3px;"></i>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div id="data-table-5_filter" class="dataTables_filter" style="text-align: left;padding-top: 5px;">
                      <!-- <select style="text-align: left;height: 26px;width: 27%;    border-radius: 4px;">
                                        <option>Search By</option>
                                    </select> -->
                                    <img src="../../assets/Images/icon/ExportImg.jpeg" alt="logo" (click)="exportexcel()" style="cursor: pointer;">
                      <!-- <button class="btn"
                        style="background: blue;color: white;padding:unset;margin: unset; margin-left: 25px;"
                        (click)="exportexcel()">Export</button> -->
                      <label style="padding-left: 50px;">Show</label>
                      <label class="switch" style="margin-left: 10px;">
                        <input type="checkbox" checked (change)="ActiveCheckboxChange($event)">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 mat-elevation-z8" style="box-shadow: unset;padding-top: 30px ;" #TABLE>
                    <table mat-table [dataSource]="dataSource" #table style="width: 100%;" matSortmat-table
                      [dataSource]="dataSource" #table style="width: 100%;" matSort>
                      <ng-container matColumnDef="sno" >
                        <th mat-header-cell *matHeaderCellDef  style="color: white !important;background-color: #ED562E"> S.NO </th>
                        <td mat-cell  *matCellDef="let item; let j = index"> {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }} </td>
                      </ng-container>
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                          style="color: white !important;background-color: #ED562E"> RESTAURANT NAME </th>
                        <td mat-cell *matCellDef="let element" (click)="EditResturant(element)"> {{element.name}} </td>
                      </ng-container>
                      <ng-container matColumnDef="emailId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                          style="color: white !important;background-color: #ED562E"> EMAIL ID </th>
                        <td mat-cell *matCellDef="let element" (click)="EditResturant(element)">
                          {{element.emailId}} </td>
                      </ng-container>
                      <ng-container matColumnDef="mobileNo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                          style="color: white !important;background-color: #ED562E"> MOBILE NO </th>
                        <td mat-cell *matCellDef="let element" (click)="EditResturant(element)"> {{element.mobileNo}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="phoneNo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                          style="color: white !important;background-color: #ED562E"> PHONE NO </th>
                        <td mat-cell *matCellDef="let element" (click)="EditResturant(element)"> {{element.phoneNo}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                          style="color: white !important;background-color: #ED562E"> STATUS </th>
                        <td mat-cell *matCellDef="let element" (click)="EditResturant(element)"> {{element.status}} </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]" showFirstLastButtons></mat-paginator>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>

</main>